export default "__VITE_ASSET__Co2TgVu9__"